import React, { useMemo } from "react"
import { useSelector } from "react-redux"
import {totalMessagesCount} from   '../../../slices/inboxSlice'

function useInboxMessageCount() {
    const bookings = useSelector(state => state.booking.items)
    const total =  useMemo(() => totalMessagesCount(bookings), [bookings]);
    return total;
}

export default useInboxMessageCount
